import { useEffect, useState } from 'react'

export const websiteFaviconUrl = (name?: string) =>
	name
		? `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&url=http://${name.replace(
				/http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g,
				''
		  )}&size=32`
		: null

// Match the website selector: failed images and small default icons use the globe.
export const useWebsiteFavicon = (name?: string, avatar?: string | null) => {
	const url = avatar ? null : websiteFaviconUrl(name)
	const [loadedUrl, setLoadedUrl] = useState<string | null>(null)
	useEffect(() => {
		setLoadedUrl(null)
		if (!url) return
		const image = new Image()
		image.onload = () => setLoadedUrl(image.naturalWidth >= 32 ? url : null)
		image.onerror = () => setLoadedUrl(null)
		image.src = url
		return () => {
			image.onload = null
			image.onerror = null
		}
	}, [url])
	return !!url && loadedUrl === url
}
